import { Span } from '@ahmdigital/ui';
import React from 'react';

import styles from './styles.module.sass';

type FeatureHighlightProps = {
  text: string;
};

const FeatureHighlight = ({ text }: FeatureHighlightProps) => (
  <Span variant={['simpleBit', styles.featureHighlight]}>{text}</Span>
);

export default FeatureHighlight;
